module.exports = __webpack_public_path__ + "img/aca07af.jpg";